import { Box, Button, Center, Flex, Link, Text } from "@chakra-ui/react";
import { RESTAKE_CTA } from "@constants/analytics";
import { trackEvent } from "dapp-sdk-v2";
import Icon from "dapp-sdk-v2/components/Icon";
import BaseImage from "dapp-sdk-v2/components/Image";
import { Close } from "icons";
import CountDown from "./Countown";

const RESTAKE_BENEFITS = [
  // {
  //   key: "boost",
  //   text: "30% staking rewards boost*",
  //   img: "/assets/images/restake/boost.svg",
  // },
  {
    key: "eigen",
    text: "Upto 4Mn Extra EigenLayer points",
    img: "/assets/images/restake/eigen.svg",
    link: "https://www.staderlabs.com/blogs/eigenboost-3-0-power-up-your-ethx-restakes/",
  },
  {
    key: "kelp",
    text: "100K Bonus Kelp Miles per rsETH",
    img: "/assets/images/restake/kelp.svg",
    link: "https://blog.kelpdao.xyz/introducing-bonus-kelp-miles-100k-bonus-miles-for-every-rseth-minted-51accec91a31/",
  },
];

interface RestakeBannerProps {
  onClose: () => void;
}

const RestakeBanner = ({ onClose }: RestakeBannerProps) => {
  return (
    <Flex
      gap="24px"
      flexDir="column"
      p={{ base: "16px", xl: "24px" }}
      bg="#CCEFEF"
      borderRadius="24px"
      mb={{ base: "16px", md: "24px" }}
      position="relative"
      mt={{ xl: "-88px" }}
    >
      <Flex
        gap={{ base: "16px", xl: "12px" }}
        alignItems={{ base: "flex-start", xl: "center" }}
        flexDir={{ base: "column", xl: "row" }}
      >
        <Box w="238px">
          <Text
            fontWeight="600"
            fontSize={{ base: "16px", md: "20px" }}
            lineHeight="24px"
            color="#142528"
          >
            EigenBoost 3.0
          </Text>
          <Text
            fontWeight="500"
            fontSize={{ base: "10px", md: "12px" }}
            lineHeight={{ base: "14px", md: "18px" }}
            color="#3F6870"
            mt="4px"
          >
            <Flex
              gap={{ base: "2px", md: 0 }}
              flexDir={{ base: "row", md: "column" }}
            >
              <Text>Restake ETHx on Kelp by</Text>
              <Text>May 20th to get attractive rewards</Text>
            </Flex>
          </Text>
        </Box>

        <Flex
          flexDir="column"
          gap="12px"
          fontSize="12px"
          lineHeight="18px"
          color="#142528"
          paddingRight="8px"
        >
          {RESTAKE_BENEFITS.map((data) => (
            <Flex key={data.key} gap="12px" alignItems="center">
              <BaseImage src={data.img} width={26} height={26} alt={data.key} />
              <Link display="flex" href={data.link} isExternal gap="4px">
                <Text fontWeight="500">{data.text}</Text>
                <BaseImage
                  src="/assets/images/arrow.svg"
                  alt="arrow"
                  width={20}
                  height={20}
                />
              </Link>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex
        gap={{ base: "24px", xl: "40px" }}
        alignItems={{ base: "flex-start", xl: "center" }}
        flexDir={{ base: "column", xl: "row" }}
      >
        <Flex
          flexDir={{ base: "row", md: "column" }}
          gap={{ base: "16px", md: "8px" }}
          w={{ base: "100%", md: "200px" }}
          alignItems={{ base: "center", md: "flex-start" }}
        >
          <Text
            fontSize="14px"
            fontWeight="600"
            lineHeight="20px"
            color="#142528"
          >
            Ending soon
          </Text>
          <CountDown />
        </Flex>
        <Flex
          flexDir="column"
          gap="8px"
          flex="1"
          w="100%"
          // alignItems={{ base: "flex-start", xl: "flex-end" }}
        >
          <Link
            href="https://kelpdao.xyz/restake/?utm_source=stader_labs"
            isExternal
            w="100%"
            maxW={{ base: "100%", md: "248px" }}
            _hover={{
              textDecor: "none",
            }}
          >
            <Button
              bg="#075A5A"
              borderRadius="6px"
              h="48px"
              color="white"
              variant="unstyled"
              w="100%"
              display="block"
              // W={{ base: "100%", md: "276px" }}
              onClick={() => trackEvent(RESTAKE_CTA)}
            >
              <Text
                fontWeight="700"
                fontSize="12px"
                lineHeight="16px"
                letterSpacing="0.5px"
              >
                RESTAKE NOW
              </Text>
            </Button>
          </Link>
        </Flex>

        {/* <Text
          color="#142528"
          fontWeight="700"
          fontSize="10px"
          lineHeight="16px"
          textAlign="center"
          w="100%"
          maxW={{ base: "100%", md: "276px" }}
        >
          *{" "}
          <Link
            href="https://www.staderlabs.com/docs-v1/Ethereum/Launch%20Incentives/Restaking%20ETHx%20with%20Kelp/"
            isExternal
            key="terms"
            borderBottom="1px solid"
            _hover={{
              textDecor: "none",
            }}
          >
            Terms and conditions
          </Link>
        </Text> */}
      </Flex>

      <Center
        bg="#ADDCDC"
        borderRadius="40px"
        w="28px"
        h="28px"
        position="absolute"
        top={{ base: "6px", md: "8px" }}
        right={{ base: "6px", md: "8px" }}
        cursor="pointer"
        onClick={onClose}
      >
        <Icon Icon={Close} height="16px" width="16px" color="closeIcon" />
      </Center>
    </Flex>
  );
};

export default RestakeBanner;
